var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 485.99 485.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n        .cls-1{\n            fill:none;\n            stroke:#fff;\n            stroke-miterlimit:10;\n            stroke-width:9px;\n        }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 243,
    r: 243
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.92,442.38A13.17,13.17,0,0,1,274,432l-40.07-179.2-71.77-.39-28,125a13.26,13.26,0,0,1-25.86.06L79.43,252l-31.52-.17a13.25,13.25,0,0,1-12.62-17.07c7-23.21,13.89-47,20.38-69.3a13.26,13.26,0,0,1,25.66.74L96.2,231l49.13.27L185.12,54A13.26,13.26,0,0,1,211,54l39.78,177.89,73.11.4,26.92-117.9a13.26,13.26,0,0,1,25.84-.05L404.14,232.7l33.88.18a13.28,13.28,0,0,1,12.77,16.75c-7,25.72-14,51.15-20.94,76.55a13.26,13.26,0,0,1-25.7-.52l-16.73-72-46.78-.25-40.8,178.68A13.19,13.19,0,0,1,286.92,442.38Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5f6b8ab66085e97bb5bedb9c8243ddd4.svg";
export { ForwardRef as ReactComponent };